var map = {
	"./chance0.png": "aa00",
	"./chance1.png": "2bd3",
	"./chance2.png": "bed2",
	"./chance3.png": "a167",
	"./chance4.png": "a5cd",
	"./chance5.png": "7e9c",
	"./chance6.png": "49b6",
	"./chance_left.png": "0896",
	"./chance_right.png": "1da5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be0f";